import type { CrudSearchItem, CrudTableColumn } from '@/types/crud-config'
import type { CustomerStatisticsInternalRecord } from './customer-statistics-internal.service'

export const createSearchItems = (): CrudSearchItem[] => [
  {
    prop: 'corpId',
    label: '主体',
    type: 'select',
    clearable: true,
    placeholder: '请选择主体',
    options: []
  },
  {
    prop: 'sid',
    label: '账号ID',
    type: 'input',
    clearable: true,
    placeholder: '请输入账号ID'
  },
  {
    prop: 'usedBy',
    label: '使用人',
    type: 'select',
    clearable: true,
    placeholder: '请选择使用人',
    options: []
  },
  {
    prop: 'uname',
    label: '客户昵称',
    type: 'input',
    clearable: true,
    placeholder: '请输入客户昵称'
  },
  {
    prop: 'isNewRepeat',
    label: '是否重复客户',
    type: 'select',
    clearable: true,
    placeholder: '请选择是否重复客户',
    options: [
      {
        label: '是',
        value: 1
      },
      {
        label: '否',
        value: 0
      }
    ]
  },
  {
    prop: 'isDeletedWithin24Hours',
    label: '是否24小时内删除',
    type: 'select',
    clearable: true,
    placeholder: '请选择是否24小时内删除',
    options: [
      {
        label: '是',
        value: 1
      },
      {
        label: '否',
        value: 0
      }
    ]
  },
  {
    prop: 'isDeleted',
    label: '是否已删除',
    type: 'select',
    clearable: true,
    placeholder: '请选择是否已删除',
    options: [
      {
        label: '是',
        value: 1
      },
      {
        label: '否',
        value: 0
      }
    ]
  },
  {
    prop: 'isInAfterSales',
    label: '是否在售后主体',
    type: 'select',
    clearable: true,
    placeholder: '请选择是否在售后主体',
    options: [
      {
        label: '是',
        value: 1
      },
      {
        label: '否',
        value: 0
      }
    ]
  },
  {
    prop: 'hasCallOnAssignedDay',
    label: '当天是否去电',
    type: 'select',
    clearable: true,
    placeholder: '请选择当天是否去电',
    options: [
      {
        label: '是',
        value: 1
      },
      {
        label: '否',
        value: 0
      }
    ]
  },
  {
    prop: 'hasConnectedCallOnAssignedDay',
    label: '当天是否接通',
    type: 'select',
    clearable: true,
    placeholder: '请选择当天是否接通',
    options: [
      {
        label: '是',
        value: 1
      },
      {
        label: '否',
        value: 0
      }
    ]
  },
  {
    prop: 'isNoDevelopPendingTransfer',
    label: '不可开发转移',
    type: 'select',
    clearable: true,
    placeholder: '请选择是否触发不可开发待转移',
    options: [
      {
        label: '是',
        value: 1
      },
      {
        label: '否',
        value: 0
      }
    ]
  },
  {
    prop: 'uid',
    label: '客户ID',
    type: 'input',
    clearable: true,
    placeholder: '请输入客户ID'
  },
  {
    prop: 'unionid',
    label: 'UnionId',
    type: 'input',
    clearable: true,
    placeholder: '请输入客户unionId'
  },
  {
    prop: 'thirdParty',
    label: '所属第三方',
    type: 'select',
    clearable: true,
    placeholder: '请选择所属第三方',
    options: []
  },
  {
    prop: 'groupName',
    label: '所属组',
    type: 'select',
    clearable: true,
    placeholder: '请选择所属组',
    options: []
  },
  {
    prop: 'sourceLabel',
    label: '来源渠道',
    type: 'select',
    clearable: true,
    placeholder: '请选择来源渠道',
    options: []
  },
  {
    prop: 'createdAtRange',
    label: '加入时间',
    type: 'dateRange',
    clearable: true,
    valueFormat: 'YYYY-MM-DD',
    startPlaceholder: '开始日期',
    endPlaceholder: '结束日期'
  }
]

export const tableColumns: (CrudTableColumn<CustomerStatisticsInternalRecord> & {
  headerTip?: string
})[] = [
  {
    prop: 'uname',
    label: '客户昵称',
    minWidth: '220',
    align: 'left',
    slot: 'consumer'
  },
  {
    prop: 'isNewRepeat',
    label: '是否重复客户',
    minWidth: '120',
    slot: 'isNewRepeat'
  },
  {
    prop: 'isDeletedWithin24Hours',
    label: '是否24小时内删除',
    minWidth: '130',
    slot: 'isDeletedWithin24Hours'
  },
  {
    prop: 'isDeleted',
    label: '是否已删除',
    minWidth: '100',
    slot: 'isDeleted'
  },
  {
    prop: 'isInAfterSales',
    label: '是否在售后主体',
    minWidth: '120',
    slot: 'isInAfterSales'
  },
  {
    prop: 'hasCallOnAssignedDay',
    label: '当天是否去电',
    minWidth: '130',
    headerTip: '新资源承接当天是否去电',
    slot: 'hasCallOnAssignedDay'
  },
  {
    prop: 'hasConnectedCallOnAssignedDay',
    label: '当天是否接通',
    minWidth: '130',
    headerTip: '新资源承接当天去电是否有接通',
    slot: 'hasConnectedCallOnAssignedDay'
  },
  {
    prop: 'isNoDevelopPendingTransfer',
    label: '不可开发转移',
    minWidth: '130',
    headerTip: '是否触发不可开发待转移',
    slot: 'isNoDevelopPendingTransfer'
  },
  {
    prop: 'uid',
    label: '客户ID',
    minWidth: '80',
    align: 'left'
  },
  {
    prop: 'unionid',
    label: 'UnionID',
    minWidth: '80',
    align: 'left'
  },
  {
    prop: 'corpName',
    label: '主体名称',
    minWidth: '70',
    align: 'left'
  },
  {
    prop: 'sid',
    label: '账号ID',
    minWidth: '80',
    align: 'left'
  },
  {
    prop: 'usedBy',
    label: '使用人',
    minWidth: '80',
    align: 'left'
  },
  {
    prop: 'groupName',
    label: '所属组',
    minWidth: '80',
    align: 'left'
  },
  {
    prop: 'sourceLabel',
    label: '来源渠道',
    minWidth: '80',
    align: 'left'
  },
  {
    prop: 'thirdParty',
    label: '第三方',
    minWidth: '80'
  },
  {
    prop: 'createdAt',
    label: '加入时间',
    minWidth: '80',
    align: 'left',
    sortable: 'custom'
  }
]
